module.exports = __webpack_public_path__ + "img/Qodana_icon.cecaf658.png";